/**
 * HomeSafetyCard — план за дома при риск от падане (Nerve2).
 * Показва се само при реален риск; отметките се пазят на сървъра.
 */
import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { CheckCircle2, Circle, Home, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const HomeSafetyCard = ({ d, setD, cardCls, border }) => {
  const h = d?.home_safety;
  const [busy, setBusy] = useState(false);
  if (!h) return null;

  const toggle = async (key) => {
    const done = h.groups.flatMap((g) => g.items).filter((i) => i.done).map((i) => i.key);
    const next = done.includes(key) ? done.filter((k) => k !== key) : [...done, key];
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/neuro-twin/home-safety`, { done: next });
      setD(data);
    } catch { toast.error("Не се записа"); }
    finally { setBusy(false); }
  };

  return (
    <div className={cardCls} data-testid="neuro-home-safety-card">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div className="min-w-0">
          <div className="text-sm font-bold inline-flex items-center gap-1.5">
            <Home className="w-4 h-4 text-violet-500" /> План за дома
            {busy && <Loader2 className="w-3.5 h-3.5 animate-spin opacity-60" />}
          </div>
          <p className="text-[12px] opacity-80 mt-1">{h.intro_bg}</p>
        </div>
        <div className="text-right shrink-0">
          <div className="text-2xl font-extrabold tabular-nums" data-testid="neuro-home-progress">
            {h.done_count}/{h.total}
          </div>
          <div className="text-[10px] opacity-70">готови</div>
        </div>
      </div>

      <div className="mt-2 h-1.5 rounded-full overflow-hidden bg-slate-500/15">
        <div className="h-full rounded-full bg-violet-500" style={{ width: `${h.percent}%` }} />
      </div>

      {h.priority_bg?.length > 0 && (
        <p className="text-[11px] font-medium mt-2" data-testid="neuro-home-priority">
          Първо това (заради Вашите находки): {h.priority_bg.join(" · ")}
        </p>
      )}

      <div className="mt-3 space-y-3">
        {h.groups.map((g) => (
          <div key={g.title_bg}>
            <div className="text-[10px] uppercase tracking-wider font-bold opacity-50">
              {g.title_bg}
            </div>
            <div className="mt-1 space-y-1.5">
              {g.items.map((i) => (
                <button key={i.key} type="button" onClick={() => toggle(i.key)} disabled={busy}
                  className={`w-full text-left p-2 rounded-lg border transition-colors ${
                    i.done ? "border-emerald-500/40 bg-emerald-500/10" : border}`}
                  data-testid={`neuro-home-item-${i.key}`}>
                  <div className="text-[12px] font-semibold inline-flex items-start gap-1.5">
                    {i.done ? <CheckCircle2 className="w-3.5 h-3.5 mt-0.5 shrink-0" />
                            : <Circle className="w-3.5 h-3.5 mt-0.5 shrink-0 opacity-50" />}
                    <span>{i.label_bg}</span>
                  </div>
                  <div className="text-[10px] opacity-75 mt-0.5 pl-5">{i.why_bg}</div>
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomeSafetyCard;
